// extracted by mini-css-extract-plugin
export default {"gradientCode":"g84ID1nsbl","section":"_6vKdtbfe0U","title":"jCc7BahDw4"};